module.exports = __webpack_public_path__ + "assets/img/Deauville_008.e09b0c35.jpg";